import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthorizationService } from '@core/authorization/services/authorization.service';
import { ApplicationPath } from '@core/navigation/models/application-path.enum';
import { PermissionsFacade } from '@core/permissions/facades/permissions.facade';
import { map } from 'rxjs';

export const hasKaseyaStoreAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const authorizationService = inject(AuthorizationService);
  const permissionsFacade = inject(PermissionsFacade);
  const { targetPage } = route.queryParams;

  if (!targetPage) {
    return router.createUrlTree([ApplicationPath.Login]);
  }

  if (!authorizationService.isAuthorized()) {
    return router.createUrlTree(['login/store'], { queryParams: { targetPage } });
  }

  return permissionsFacade.permissionsLoaded$.pipe(map(() => true));
};
